import { useEffect, useState, useRef } from "react";
import Sider from "../../comps/sider/main";
import './main.css';
import {TagTwoTone, ClockCircleOutlined, CommentOutlined, UserSwitchOutlined, EyeInvisibleOutlined, DeleteOutlined, PlusOutlined, SendOutlined, ThunderboltOutlined, GlobalOutlined, UploadOutlined, UserAddOutlined, CopyOutlined, CrownOutlined, FireFilled, PlusSquareOutlined, AppleFilled, MailOutlined, CameraOutlined, EyeOutlined, RightOutlined, RightCircleOutlined, RocketOutlined } from '@ant-design/icons';
import { Alert, Switch, Drawer, Radio, Input, Card, Tag, Divider, Select, Button, Collapse, Upload, Tooltip, message, Popconfirm, Checkbox, Dropdown, Steps, Timeline, Modal } from 'antd';
import { EditText, EditTextarea } from 'react-edit-text';
import 'react-edit-text/dist/index.css';
import axios from 'axios';
import callAPI from "../../comps/fetch/main";
import { json } from "react-router-dom";

import AccessOrNot from "../../funcs/accessOrNot";
import { v4 as uuidv4 } from 'uuid';

import CrownReturn from '../crownPremium/main'
import { BsCashCoin, BsMagnet  } from "react-icons/bs";
import {InstaDMLayout} from "../instaDMLayout/main";
import ShopifyPreview from "./previewShopify";
import { set } from "lodash";
import Meta from "antd/es/card/Meta";

import { Typography, Row, Col } from "antd";
import { CheckCircleTwoTone, CloseCircleTwoTone } from "@ant-design/icons";

const { TextArea } = Input;


const { Title, Text } = Typography;

const ShopifyChoice = ({site_name,previewData,setPreviewData ,props,LoadPreview }) => {
  const [selected, setSelected] = useState( props?.state?.sp_send_type ||"sell");

  const onCardClick = (type_) => {
    let data = {
                    ...previewData,
                    send_type: {
                      type: type_,
                       
                              }
                            }
  console.log("-=-=-=-=-previewData?.sp_product?.node?.handle-=-=-=---=-=-",previewData?.sp_product?.node?.handle)
  if(type_ == "link" ){
    data["message"] = previewData?.send_type?.message || `https://${site_name}/products/${previewData?.sp_product?.node?.handle}`   

    props.setData({ ...props.state,sp_send_type:"link" , sp_send_message :  props.state?.sp_send_message || `https://${site_name}/products/${ props.state?.sp_product?.node?.handle}`})

  }
  else{
    props.setData({ ...props.state,sp_send_type:type_, sp_send_message :  props.state?.sp_send_message})
  }
  setPreviewData(data); 
  setSelected(type_)
  }

  const options = {
    instagram: [
      "Turn every comment into a customer",
      "Show product images inside DMs",
      "Auto reminders for abandoned carts",
      "Upsells & product recommendations",
      "Build repeat buyers with community",
      "Track sales with campaign insights",
      "Seamless Shopify checkout",
    ],
    shopify: [
      "No product images in DMs",
      "No follow-ups → abandoned carts",
      "No upsells = lost revenue",
      "No community = fewer repeat buyers",
      "No tracking = no insights",
    ],
  };

  return (
    <div style={{ padding: "40px", textAlign: "center", background: "#ffffffff" }}>
      <Title level={2}>What do you want to do?</Title>

      <Row gutter={[24, 24]} justify="center" style={{ marginTop: 32 }}>
        {/* Instagram Card */}


        {/* Shopify Link Card */}
        <Col xs={24} md={10}>
          <Card
            title={<Text strong>Just Share Shopify Link</Text>}
            hoverable
            bordered={selected === "link"}
            onClick={() => onCardClick("link")}
            style={{
              borderRadius: 12,
              border: selected === "link" ? "1px solid #722ed1" : "1px solid #00000028",
            }}
          >
            {options.shopify.map((item, i) => (
              <div key={i} style={{ margin: "8px 0", textAlign: "left" }}>
                <CloseCircleTwoTone twoToneColor="#ff4d4f" />{" "}
                <Text>{item}</Text>
              </div>
            ))}


            {props.state?.sp_send_type === "link"  &&   <p style={{color:"blue"}}>Customize your message 👇👇</p> }
              {props.state?.sp_send_type === "link"  && <Input.TextArea onChange={(e) => {
                
                setPreviewData({...previewData, send_type:{
                ...previewData.send_type, message: e.target.value
              }
            })
            props.setData({...props.state,sp_send_message:e.target.value })
          
          }} value={props.state?.sp_send_message} />
                }
          </Card>
        </Col>

          <Col xs={24} md={10}>
          <Card
            title={
              <div>
                <Text strong>Sell on Instagram</Text>
                <br />
                <Text
                  style={{
                    fontSize: 12,
                    background: "#f0e9ff",
                    padding: "2px 8px",
                    borderRadius: 12,
                    color: "#722ed1",
                  }}
                >
                  Recommended
                </Text>
              </div>
            }
            hoverable
            bordered={selected === "sell"}
            onClick={() => onCardClick("sell")}
            style={{
              borderRadius: 12,
              border: selected === "sell" ? "1px solid #722ed1" : "1px solid #00000028",
              
            }}
          >
            {options.instagram.map((item, i) => (
              <div key={i} style={{ margin: "8px 0", textAlign: "left" }}>
                <CheckCircleTwoTone twoToneColor="#52c41a" />{" "}
                <Text>{item}</Text>
              </div>
            ))}
          </Card>
        </Col>
      </Row>

      {/* CTA */}
      {/* {selected == "sell" && <Button
        type="primary"
        size="large"
        onClick={LoadPreview}
        style={{
          marginTop: 32,
          borderRadius: 8,
          background: "linear-gradient(90deg, #722ed1, #9254de)",
        }}
      >
        Preview Experience
      </Button> } */}
    </div>
  );
};



const htmlToText = (html) => {
      try {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        console.log("=-=-=-=-=-doc.body.textContent" , doc.body.textContent)
        if(doc.body.textContent == "undefined" || doc.body.textContent == null || doc.body.textContent == "null") 
          return ""
        return doc.body.textContent || "";
      } catch (err) {
        console.error("Error in htmlToText:", err);
        return "";
      }
};

const generateFollowupOptions = () => {
  let opts = [
    {"label":"1 minutes" , "value":"1"},
    {"label":"2 minutes" , "value":"2"},
    {"label":"3 minutes" , "value":"3"},
    {"label":"4 minutes" , "value":"4"},
  ];

  // 5 min intervals up to 1 hour
  for (let i = 5; i <= 60; i += 5) {
    opts.push({ value: `${i}`, label: `${i} minutes` });
  }

  // Hour intervals (1h to 24h)
  for (let i = 1; i <= 24; i++) {
    opts.push({ value: `${i*60}`, label: `${i} hour${i > 1 ? "s" : ""}` });
  }

  // // Day intervals (1–7 days)
  // for (let i = 1; i <= 7; i++) {
  //   opts.push({ value: `${i*60*24}d`, label: `${i} day${i > 1 ? "s" : ""}` });
  // }

  return opts;
};

const FollowupSection = ({ varient, old_messages = [], setFollowupMessages }) => {
  
  
  // const [followups, setFollowups] = useState(
  //   [...old_messages] || [{ follow_up_time: "15", message: "" }]
  // );

  // useEffect(() => {
  //   console.log("-=-=-=-=-=-followups" , followups, old_messages)
  //   // console.log(JSON.stringify(followups) == JSON.stringify(old_messages))
  //   if (JSON.stringify(followups) !== JSON.stringify(old_messages)) {
  //     console.log("Follow up changes-=-=-=-=-=-",)
  //     setFollowupMessages((prev) => ({
  //       ...prev,
  //       [varient]: followups.reduce((acc, curr, index) => {
  //         acc[index + 1] = {
  //           follow_up_time: curr.follow_up_time,
  //           title: curr.title || "",
  //           subtitle: curr.subtitle || "",
  //           btn_text1: curr.btn_text1 || "",
  //         };
  //         return acc;
  //       }, {}),
  //     }));
  //   }
  // }, [followups]);


   const initialFollowups = Object.keys(old_messages).length
    ? old_messages
    : [{ follow_up_time: "15", title: "", subtitle: "", btn_text1: "" }];

  const [followups, setFollowups] = useState(initialFollowups);

  useEffect(() => {
    // Sync parent state whenever followups change
    setFollowupMessages((prev) => ({
      ...prev,
      [varient]: followups.reduce((acc, curr, index) => {
        acc[index + 1] = {
          follow_up_time: curr.follow_up_time,
          title: curr.title || "",
          subtitle: curr.subtitle || "",
          btn_text1: curr.btn_text1 || "",
        };
        return acc;
      }, {}),
    }));
  }, [followups, varient, setFollowupMessages]);


  const followup_options = generateFollowupOptions();

  const updateFollowup = (index, field, value) => {
    const updated = [...followups];
    updated[index][field] = value;
    setFollowups(updated);
  };

  const addFollowup = () => {
    setFollowups([...followups, { follow_up_time: "15", message: "" }]);
  };

    const deleteFollowup = (index) => {
    const updated = [...followups];
    updated.splice(index, 1);
    setFollowups(updated);
  };

  return (
    <div>
       <Timeline>
        {/* Step 0: initial message */}
        <Timeline.Item color="green">
          <div style={{ fontWeight: "bold" }}>{varient =="left_chat" ? "Message Sent" : "Added to cart but not purchased."}</div>
          <div style={{ fontStyle: "italic", color: "#666" }}>
            {varient =="left_chat" ? "Your configured message will be sent." : <p>If lead added product to cart but not purchased, <br/>the below follow up messages will sent.</p> }
          </div>
        </Timeline.Item>

        {/* Followups */}

        {followups.map((f, i) => (
            <Timeline.Item key={i} color="blue">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: 6,
                }}
              >
                <span style={{ fontWeight: "600", fontSize: 15 }}>
                  Follow-up #{i + 1}
                </span>
                <Popconfirm
                  title="Are you sure you want to delete this follow-up?"
                  okText="Delete"
                  cancelText="Cancel"
                  onConfirm={() => deleteFollowup(i)}
                >
                  <DeleteOutlined
                    style={{ color: "red", cursor: "pointer", fontSize: 16 }}
                  />
                </Popconfirm>
              </div>

              <div style={{ marginBottom: 10, fontSize: 13, color: "#555" }}>
                Wait{" "}
                <Select
                  size="small"
                  style={{ width: 160 }}
                  value={f.follow_up_time}
                  options={followup_options}
                  onChange={(val) => updateFollowup(i, "follow_up_time", val)}
                />{" "}
                after {i == 0 ? varient =="left_chat" ? "Message Sent" : "Added to card" : `Follow-up #${i}`}
              </div>

              <Input
                placeholder="Enter follow-up message hook..."
                value={f.title}
                onChange={(e) => updateFollowup(i, "title", e.target.value)}
                style={{marginBottom:"10px"}}
              />
              <Input.TextArea
                rows={3}
                placeholder="Add follow-up description..."
                value={f.subtitle}
                style={{marginBottom:"10px"}}

                onChange={(e) => updateFollowup(i, "subtitle", e.target.value)}
              />
              <Input value={f.btn_text1} onChange={(e) => updateFollowup(i, "btn_text1", e.target.value)} placeholder="CTA Text"/>
            </Timeline.Item>
          ))}

         <Timeline.Item
            color="orange"
            
            dot={
              <Button
                color="default" variant="solid"
                size="small"
                onClick={followups.length > 4 ? () => {} : addFollowup}
                style={{ borderRadius: "50%" }}
                icon={<PlusOutlined />}
              >
                
              </Button>
            }
          >
            <span 
            onClick={followups.length > 4 ? () => {} : addFollowup}
            style={{ color: "#555", cursor:"pointer" }}>Add Another Followup Message {followups.length > 4 && <Tag color="orange">Limit Reached</Tag> }</span>
          </Timeline.Item>
         
         
         <Timeline.Item color="red">
          <div style={{ fontWeight: "bold", marginBottom: 8 }}>
            Change Status to <Tag style={{ fontWeight: "500"}} color="red">Not Interested</Tag>
          </div>
          {/* <Select
            style={{ width: 200 }}
            value={finalStatus}
            options={final_status_options}
            onChange={setFinalStatus}
          /> */}
          <div style={{ marginTop: 6, color: "#888", fontSize: 13 }}>
            This marks the end of the sequence when the user not responded any of the above followup message.
          </div>
        </Timeline.Item>
      </Timeline>


    </div>
  );
};


function PostPurchaseTimeline({products, postPurchase, setPostPurchase}) {

  const [steps, setSteps] = useState(postPurchase?.length > 0 ? postPurchase :[
    { type:"order-confirm", enabled: true, "delay":"now" , message: "Thanks for your purchase! Tracking details will be shared soon."},
  ]);

  useEffect(() => {

    if(JSON.stringify(steps) != JSON.stringify(postPurchase)){

      setPostPurchase(steps)

    }

  },[steps,setPostPurchase,postPurchase])
  const addStep = (type) => {
    if(steps?.length > 4){
      message.warning("Maximum post purchase message reached.")
      return
    }
    let new_step = { type, enabled: true, "delay":"5"}
    if (type =="upsell"){
      new_step["products"] = [null,]
      new_step["title"] = "Recommended product for you!";
    }
    if (type =="whatsapp"){
      new_step["cta"] = "Join Community"
      new_step["message"] = "Join our WhatsApp community for exclusive updates!";
      new_step["link"] = "https://chat.whatsapp.com/your-community-link";
    }
    if (type =="order-confirm"){
      new_step["message"] = "Thanks for your purchase! Tracking details will be shared soon.";
    }
    setSteps([...steps, new_step]);
    console.log("-=-=-=-=-=-= added new product -=-=--=-=-")
  };

  const updateStep = (i, k, v) => {

    let changes = steps.map((s, idx) => (idx === i ? { ...s, [k]:v } : s))
    console.log("changes-=-=-=-=-", changes)
    setSteps(changes);

  };

  const deleteStep = (i) => {
    setSteps(steps.filter((_, idx) => idx !== i));
  };

  const postPurchaseTypes = [
  { label: "Order Confirmed", value: "order-confirm" },
  { label: "WhatsApp Community Link", value: "whatsapp" },
  { label: "Upsell / Recommended Products", value: "upsell" },
  // { label: "Custom Message", value: "custom" },

];


  const [selectedUpsellIndex, setSelectedUpsellIndex] = useState(null)

  const stepTypeTitle = (type) =>{

      if(type ===   "order-confirm") return "Order Confirmed"
      if(type ===   "whatsapp") return "WhatsApp Community Link"
      if(type ===  "upsell") return "Upsell Product"

  }


let delayOptions = [{"label":"Immediately","value":"now"},...generateFollowupOptions(), ]
  return (
    <div
      style={{
        backgroundColor: "white",
        minWidth: "350px",
        padding: "20px",
        borderRadius: "10px 20px 10px 20px",
      }}
    >
      {/* Header */}
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          marginBottom: 20,
        }}
      >
        <h3>Post Purchase</h3>
        <RocketOutlined style={{ fontSize: "20px" }} />
      </div>

      {/* Timeline */}
      <Timeline>
        {steps.map((step, i) => (
          <Timeline.Item key={i} color="blue">
            <div
              style={{
                fontWeight: "bold",
                marginBottom: 8,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              {stepTypeTitle(step.type)}
              <div>
                <Popconfirm
                  title="Delete this step?"
                  onConfirm={() => deleteStep(i)}
                >
                  <DeleteOutlined style={{ color: "red", cursor: "pointer" }} />
                </Popconfirm>
              </div>
            </div>

            {/* Delay */}
            <div style={{ marginBottom: 10, color: "#666" }}>
              
              <Select
                style={{ width: 150 }}
                value={step.delay}
                options={delayOptions}
                onChange={(val) => updateStep(i, "delay", val)}
              />{" "}
              { i ==0 ? "after purchase completed" : 
              
              `after ${stepTypeTitle(steps[i-1]?.type)}`
              }
            </div>

            {/* Dynamic Fields by Type */}
            {step.type === "order-confirm" && (
              <Input.TextArea
                placeholder="Thanks for your purchase! Tracking details will be shared soon."
                value={step.message}
                onChange={(e) => updateStep(i, "message", e.target.value)}
              />
            )}

            {step.type === "whatsapp" && <div>
              <Input.TextArea
                placeholder="Enter WhatsApp group/community link"
                value={step.message}
                onChange={(e) => updateStep(i, "message", e.target.value)}
                style={{marginBottom:"10px"}}
              />
              <Input 
                onChange={(e) => updateStep(i, "cta", e.target.value)}
                value={step.cta}

                style={{marginBottom:"10px"}}
              
              placeholder="CTA Text"/>
              <Input
                value={step.link}

                onChange={(e) => updateStep(i, "link", e.target.value)}
                style={{marginBottom:"10px"}}
              
              placeholder="Whatsapp Link" />
              </div>
            }

            {step.type === "upsell" && (
              <div style={{ display: "grid", gap: 10 }}>
                <Input
                  placeholder="Upsell Message"
                  value={step.title}
                  onChange={(e) => updateStep(i, "title", e.target.value)}
                />

                <div style={{ display: "flex", gap: 16, overflowY:"scroll", flexWrap:"nowrap"}} >
                  {step?.products?.map((product, cardIndex) => (
                  <div style={{
                    position: "relative",
                    display: "block",
                    marginRight: 16,
                    minWidth:"30%"
                  }}>
                  {product == null ? <Button
                    color="primary" variant="dashed"
                      key={cardIndex}
                      bordered
                      style={{
                        width: "100%",
                        height: 200,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",

                      }}
                      onClick={() => setSelectedUpsellIndex({cardIndex, stepIndex:i})}
                    >
                      + Select Product
                    </Button> :

                    <Card
                    style={{width:"100%"}}
                    cover={ 
                    <img src={product?.node?.featuredMedia?.preview?.image?.url } 
                     style={{
                        width: "100%",
                        height: "160px",  
                        objectFit: "cover",
                        borderRadius: "6px"
                      }}/>
                    
                    } >

                    <Meta title={product?.title} description={htmlToText(product?.node?.descriptionHtml)?.substring(0,50)}/>
                    <Input value={product?.cta} onChange={(e) => {
                      const updated = [...(step.products || [])]; // clone array
                      updated[cardIndex] = { ...updated[cardIndex], cta: e.target.value };  // replace one item
                      updateStep(i, "products", updated);
                    }} style={{marginTop:"10px"}} placeholder="CTA Text"/>
                    </Card> }
                    <DeleteOutlined
                        onClick={() => {
                          const updated = [...(step.products || [])]; // clone array
                          updated.splice(cardIndex, 1); // remove one item
                          updateStep(i, "products", updated);
                          setSelectedUpsellIndex({});
                        }}
                        style={{
                          position: "absolute",
                          top: 8,
                          right: 8,
                          fontSize: 18,
                          color: "#ff4d4f",
                          cursor: "pointer",
                          backgroundColor:"#fffffffb",
                          borderRadius: "50%",
                          padding: 4,
                          boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                        }}
                      />
                  </div>
                  
                  ))}
                  <Button

                    color="primary" variant="dashed"
                      key={"new-product"}
                      bordered
                      style={{
                        width: "30%",
                        height: 200,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",

                      }}
                      onClick={() => {
                       if(step?.products?.length <3) {

                        
                        setSelectedUpsellIndex({cardIndex:(step?.products?.length || 0 ), stepIndex:i})

                        updateStep(i, "products", [...step.products, null])
                       }
                       
                       else{
                          message.error("You can only upsell 3 products.")
                       }
                      }}
                    >
                      + Sell new product
                    </Button>
                </div>
                
              </div>
            )}
          </Timeline.Item>
        ))}
      </Timeline>

      {/* Add Step Section */}
      <div style={{ marginTop: 20 }}>
      <div style={{ marginBottom: 8, fontWeight: 500 }}>Add new message</div>

      {postPurchaseTypes.map((item) => (
        <Tag
          key={item.value}
          color="blue"
          style={{ cursor: "pointer", marginBottom: 8 }}
          onClick={() => addStep(item.value)}
        >
          {item.label}
        </Tag>
      ))}
    </div>

      <Modal onCancel={() => setSelectedUpsellIndex({})} open={selectedUpsellIndex?.cardIndex != null} title="Select a product to upsell" footer={[]}>

        <div  style={{display:"flex", flexWrap:"wrap",  flexDirection:"row", gap:"20px", overflow:"scroll",height:"auto" ,maxHeight: 600, marginBottom:"20px"}}>
           { products?.map( (product) => 

           <div style={{position:"relative"}}>
 
                        <img
                      alt={product?.node?.title}
                      
                      src={product?.node?.featuredMedia?.preview?.image?.url || "https://via.placeholder.com/300?text=No+Image"}
                      onClick={() => {

                        console.log("-=-=-=-=-=-selectedUpsellIndex",selectedUpsellIndex?.cardIndex)
                        const updated = [...(steps[selectedUpsellIndex?.stepIndex]?.products||[])]; // clone array
                        updated[selectedUpsellIndex?.cardIndex || 0] = { ...product, cta:"Explore" };  // replace one item
                        console.log("-=-=-=-=-product", product)
                        
                       updateStep(selectedUpsellIndex?.stepIndex, "products", updated)

                       setSelectedUpsellIndex({})
                      }


                      }
                      style={{ height: 160, objectFit: "cover", borderRadius:"20px", border:"1px solid rgba(0,0,0,.15)",cursor:"pointer" ,}}
                    />
                </div>
            )}
        </div>

      </Modal>
    </div>
  );
}



function ShopifyAutomate(props) {
  const [tags, setTags] = useState([]);
  const [comments, setComments] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [commentValue, setCommentValue] = useState('');
  const [isAddingTag, setIsAddingTag] = useState(false); // Combined state for tag/comment input visibility
  const [addingType, setAddingType] = useState(''); // Identify which input is being added (tag or comment)
  const inputRef = useRef(null);
  const commentRef = useRef(null);
  const [preSignedURL, setPreSignedURL] = useState()
  const [thumnailURL, setThumbnailURL] = useState(props.state?.auto_reply?.cover_image)
  const [loading, setLoading] = useState()

  const [prevStateCopy, setPrevStateCopy] = useState()
  const [prevState, setPrevState] = useState()

  const [localState, setLocalState] = useState()

  const [messageApi, contextHolder] = message.useMessage();

  const [products, setProducts] = useState();

  const [shopNotConnected, setShopNotConnected] = useState(false)

  const [slectedProduct, setSelectedProduct] = useState()
  const [sendType, setSendType] = useState("sell")



  const handleClose = (item, tag_type = "") => {
    const newItems = tag_type === 'tag' ? props.state?.auto_reply?.triger_words.filter((tag) => tag !== item) : (props.state?.auto_reply?.reply_comments || []).filter((comment) => comment !== item);
    if (tag_type === 'tag') {
      // setTags(newItems);
      // const newTags = props.state?.auto_reply?.triger_words.filter((tag) => tag !== removedTag);
      props.setData({ ...props.state, auto_reply: { ...props.state?.auto_reply, triger_words: newItems } })
    } else {
      // setComments(newItems);
      props.setData({ ...props.state, auto_reply: { ...props.state?.auto_reply, reply_comments: newItems } })
    }
  };


  const renderItem = (item, type) => (
    <span key={item} style={{ display: 'inline-block', marginBottom: '20px' }}>
      <Tag
        style={{ padding: '10px 10px', fontSize: '14px', gap: '10px' }}
        color="blue"
        closable
        onClose={(e) => {
          e.preventDefault();
          handleClose(item, type);
        }}
      >
        {item}
      </Tag>
    </span>
  );

  useEffect(() => {


    if (prevStateCopy == undefined) {
      return
    }

    if (prevStateCopy == false && prevState != undefined) {
      props.setData(prevState)
      return
    }
    if (prevStateCopy == true) {
      let prev_automation = JSON.parse(localStorage.getItem("previous_config"))
      setPrevState(props.state)
      props.setData({ ...prev_automation, post_id: props.state?.post_id, temp_post_id: props.state?.temp_post_id, id: props.id, })

    }

  }, [prevStateCopy])

  useEffect(() => {

  }, [props.isStory])

  // console.log("===============", props.state)
  const tagChild = props.state?.auto_reply?.triger_words.map((tag) => renderItem(tag, 'tag'));
  const commentChild = (props.state?.auto_reply?.reply_comments || []).map((comment) => renderItem(comment, 'comment'));

  const tagPlusStyle = {
    background: 'blue',
    borderStyle: 'dashed',
  };

  useEffect(() => {
      if (products == undefined) {
          messageApi.open({type: 'loading',
              content: 'Loading your products...',
              duration: 0,
              key:'loading'
            })
          let apiURL = `/shopify-products`
          callAPI({ url: apiURL, method: "GET", loadingState: setLoading, dataState: (data) => {
              if (data?.shop_connected == false)(
                  setShopNotConnected(true)
              )
              setProducts(
                  data?.data || []
              )
              messageApi.destroy()
          } })
      }
  }, [])

  let site_name = localStorage.getItem("shopify_store")

  let steps = ["sp_product", "trigger" , "send_type", "left_chat" , "left_order" , "post_purchase",]//"out_of_stock"]
  
  // let steps = ["trigger" , "sp_product", "send_type", "thanks"]
  
  const [currentStep, setCurrentStep] = useState(0)
  
  const [previewData, setPreviewData] = useState({})

    
  const [followupMessages, setFollowupMessages] = useState(


   props.state?.followupMessages ||  {"left_chat":{
  "1": {
    follow_up_time: "5",
    title: "Still thinking it over? 👀 Don’t miss out — your favorites might sell out soon!",
    btn_text1: "Add to Cart Now"
  },
  "2": {
    follow_up_time: "10",
    title: "Good news! 🎉 Orders placed today get FREE shipping. Your picks are waiting.",
    btn_text1: "Shop & Save"
  },
  "3": {
    follow_up_time: "15",
    title: "🔥 Bestsellers are going fast! Grab yours before it’s gone.",
    btn_text1: "Resume Checkout"
  },
  },
  "left_order":{
  "1": {
    follow_up_time: "5",
    title: "Looks like you left something behind 👋 Complete your order now and enjoy 10% OFF!",
    btn_text1: "Claim Discount & Checkout"
  },
  "2": {
    follow_up_time: "10",
    title: "Your cart is about to expire ⏳ Don’t lose your items — complete your purchase today.",
    btn_text1: "Checkout Now"
  },
  "3": {
    follow_up_time: "15",
    message: "Your cart is about to expire ⏳ Don’t lose your items — complete your purchase today..",
    btn_text1: "Finish Order"
  },
  }

} );


  const [postPurchase, setpostPurchase] = useState(props.state?.postPurchase || [])


  let default_thanks_message = "Your order confirmed. Thanks for the pruchase. Tracking details will be shared soon."

  const [thanksmessage, setThanksmessage] = useState(props.state?.thanksmessage || default_thanks_message)


  useEffect(() => {
    console.log("-=-=-date change=-=-=", props.state)
  },[props.state])

  useEffect(() => {
    
    props.setData({ ...props.state,followupMessages:followupMessages, postPurchase:postPurchase })
    console.log("follow up messages", followupMessages)
    setPreviewData({...previewData, followupMessages:followupMessages, postPurchase:postPurchase })

  },[followupMessages, postPurchase])


    useEffect(() => {
    
    props.setData({ ...props.state,thanksmessage:thanksmessage })
  },[thanksmessage])

  const [loadingExpPreivew, setLoadingExpPreview] = useState()
  const [expPreviewData, setExpPreviewData] = useState()
  function LoadPreview(){
    setExpPreviewData(props.state.sp_product)
    // callAPI({ url : "/preview-sp-exp", method:"POST", body: {"product_id": previewData?.sp_product?.id}, loadingState:setLoadingExpPreview, 
    
    // dataState: (data) => {
    //   setExpPreviewData(data?.data)
    // }})
  }

  const handleInputChange = (e) => {
    if (addingType === 'tag') {
      setInputValue(e.target.value);
    } else {
      setCommentValue(e.target.value);
    }
  };

  const handleInputConfirm = () => {
    const value = addingType === 'tag' ? inputValue : commentValue;
    if (value && ![...tags, ...comments].includes(value)) {
      if (addingType === 'tag') {

        props.setData({ ...props.state, auto_reply: { ...props.state.auto_reply, triger_words: [...props.state.auto_reply.triger_words, value] } })

      } else {
        props.setData({ ...props.state, auto_reply: { ...props.state.auto_reply, reply_comments: [...(props.state.auto_reply?.reply_comments || []), value] } })

      }
    }
    setIsAddingTag(false);
    setInputValue('');
    setCommentValue('');
  };

  const showInput = (type) => {
    setIsAddingTag(true);
    setAddingType(type);
  };


    const splitIntoChunks = (text, chunkSize = 80) => {
      if (!text) return [];

      const chunks = [];
      const lines = text.split("\n");

      for (let line of lines) {
        line = line.trim();
        if (!line) continue;

        const sentences = line.split(".").map(s => s.trim()).filter(Boolean);

        for (let sentence of sentences) {
          const words = sentence.split(" ");
          if (words.length <= chunkSize) {
            chunks.push(words.join(" "));
          } else {
            for (let i = 0; i < words.length; i += chunkSize) {
              chunks.push(words.slice(i, i + chunkSize).join(" "));
            }
          }
        }
      }

      return chunks;
    };
  const [expChat, setExpChat] = useState([])
  const [isTyping, setIsTyping] = useState(false);
  const [optionIndex, setOptionIndex] = useState(0);
  const [selectedOptionsData, setSelectedOptionsData] = useState({});
  function findMatchingVariant(productData, selectedOptions) {
  const variants = productData?.node?.options  || [];

  if (variants.length === 1) {
    return variants[0];
  }
  
  // console.log("Selected Options: ", selectedOptions , variants);
  return variants.find(variant => {
    const { option1, option2, option3 } = variant;


    const matchOption1 = !selectedOptions.option1 || selectedOptions.option1 === option1;
    const matchOption2 = !selectedOptions.option2 || selectedOptions.option2 === option2;
    const matchOption3 = !selectedOptions.option3 || selectedOptions.option3 === option3;

    return matchOption1 && matchOption2 && matchOption3;
  });
}

function buildVarientDMMessage( selectedVariant, tempselectedOptionsData) {

          let variantAvailable = true;
          let variantImage = selectedVariant?.image_id;
          let variantImageSrc = null;

          if (variantImage) {
            const imageObj = expPreviewData.images.find(img => img.id === variantImage);
            if (imageObj) {
              variantImageSrc = imageObj.src;
            }
          }

          let stocksLeft = null;
          let inventoryQty = selectedVariant?.inventory_quantity ?? 0;
          let inventoryPolicy = selectedVariant?.inventory_policy;
          // inventoryQty = 0;
          // inventoryPolicy = 0
          if (inventoryQty > 0 && inventoryQty < 10) {
            stocksLeft = `Hurry, Only ${inventoryQty} left.`;
          }

          if (inventoryQty <= 0 && inventoryPolicy !== "continue") {
            stocksLeft = `Sorry, This product is Out of stock.`;
            variantAvailable = false;
          }

          if (inventoryQty <= 0 && inventoryPolicy === "continue") {
            stocksLeft = `Hurry, only few left in stocks.`;
          }
          let mesg_add = []
          if(stocksLeft != null){
            // console.log("stocks left" , stocksLeft)
             mesg_add.push({ from: "bot", text: stocksLeft, type: "text" });
          }
         
          // let eventCoreTemp = { ...eventCore, variant_available: variantAvailable };

          let buttons = [];
          let subtitle = `${selectedVariant?.price} • ${
          [...tempselectedOptionsData]
            .filter(Boolean)
            .join(" / ")
        }`;


          if (variantAvailable) {
            const draftOrder = {} //await createShopifyDraftOrder(shopifyDetails, eventCore, `${postId}-${commentId}`);
            const paymentLink = draftOrder?.invoice_url;
            const totalPrice = draftOrder?.total_price;

            // eventCore.payment_link = paymentLink;
            // eventCore.total_price = totalPrice;

            buttons.push({
              title: "Pay Now",
              type: "web_url",
              url: paymentLink
            });

            // Optionally Add-to-Cart button
            // buttons.push({
            //   title: "Add to Cart",
            //   payload: insertPostbackData(eventCoreTemp),
            //   type: "postback"
            // });
          } else {
            // eventCoreTemp.current_sp_step = "out_of_stock";
            subtitle = `Sorry This product is currently out of stock || ${subtitle}`
            buttons.push({
              title: "Notify Me",
              // payload: insertPostbackData(eventCore),
              type: "postback"
            });
          }

          const finalMessage = {
            title: expPreviewData?.title || "Selected Variant",
            subtitle: subtitle,
            image_url: variantImageSrc,
            buttons,
            from: "bot",
            type: "button"
          };
          
          mesg_add.push(finalMessage);
          // console.log("Final Message: ", mesg_add);
          return [ ...mesg_add];

}

  function buildDMMessages(productData, optionIndex) {
    const dmMessages = [];

    const options = productData?.node?.options || [];
    // if (options.length <=1){
    //   return dmMessages;
    // }


      if (options.length-1 == 0) {
        let selected_varient = findMatchingVariant(productData, {});
        console.log("Selected varient-=-=--=-=-", selected_varient)
        return buildVarientDMMessage(selected_varient,[])
        
      }
     const option = options[optionIndex];
    
    const optionTitle = option.name;
    const optionValues = option.values;

    const buttons = [];

    optionValues.forEach((value) => {

      buttons.push({
        title: value,
        onClick: () => {
          setExpChat(prev => [...prev, { from: "user", text: value }]);
          setSelectedOptionsData({ ...selectedOptionsData, [`option${optionIndex + 1}`]: value });
          
          if (optionIndex + 1 === options.length) {
          let selectedVariant = findMatchingVariant(expPreviewData, {
            option_1: selectedOptionsData.option1,
            option_2: selectedOptionsData.option2,
            option_3: value
          });
          let messages = buildVarientDMMessage(selectedVariant,[selectedOptionsData.option1, selectedOptionsData.option2, value])

          setExpChat(prev => [...prev, ...messages]);
         
        }
          else{
          let messages = buildDMMessages(expPreviewData, optionIndex+1)
          
          if (messages?.length) {
            messages.forEach((message, index) => {
              setTimeout(() => {
                setExpChat(prev => [...prev, message]);
                if (index === messages.length - 1) {
                  setTimeout(() => {
                    setIsTyping(false);
                  }, 500);
                }
              }, (index + 1) * 500); // 1000ms gap between each
            });
          }
        }
        }
      });
    });


      dmMessages.push({
        text: `Select ${optionTitle}`,
        from: "bot",
        type: "text"
      });

      const productTemplate = [];
      let tempBtns = [];

      buttons.forEach((btn, idx) => {
        tempBtns.push({ ...btn, type: "postback" });

        // Every 3 buttons, push a new element
        if ((idx + 1) % 3 === 0) {
          productTemplate.push({
            title: "",
            buttons: tempBtns
          });
          tempBtns = [];
        }
      });

      // Push remaining buttons if any
      if (tempBtns.length > 0) {
        productTemplate.push({
          title: "",
          buttons: tempBtns
        });
      }

      dmMessages.push({
            products:productTemplate,
            from: "bot",
            type: "products"

      });

    

    // console.log("DM Messages: ", dmMessages);
    return dmMessages;
  }




  const handleShopClick = () => {

  setIsTyping(true);
  // Add user's message
  setExpChat(prev => [...prev, { from: "user", text: "Shop" }]);
  

  // Then simulate images from bot
  let messages = []
  let chunks = splitIntoChunks(htmlToText(expPreviewData?.node?.description))
  let images = expPreviewData?.node?.media?.nodes || [];
  chunks.forEach((chunk, index) => {
    messages.push({ from: "bot", type: "text", text: chunk });
  });
  images.forEach((img, index) => {
    messages.push({ from: "bot", type: "image", src: img?.preview?.image?.url });
  });

  buildDMMessages(expPreviewData , 0).forEach((message, index) => {
    messages.push({ ...message });
  });
  
  if (messages?.length) {
    messages.forEach((message, index) => {
      setTimeout(() => {
        
        setExpChat(prev => [...prev, message]);
        if (index === messages.length - 1) {
        setTimeout(() => {
          setIsTyping(false);
        }, 500);
      }
      }, (index + 1) * 500); // 1000ms gap between each
    });
  }
};


  // console.log( "-==-=-=-=-ig data-=-=-" , props.igData)
// console.log("-=-=-selectedFollowup-=-=",selectedFollowup,followupMessages["left_chat"][selectedFollowup]?.follow_up_time)
  return (
    <div style={{display:"flex" , flexDirection:"row", overflow:"scroll" , flexWrap:"nowrap"}}>

      <div className="desktop" style={{flex:"1"}}>
        <ShopifyPreview igData={props.igData} step={steps[currentStep]} data = {props.state} previewData={previewData} />
        {/* data={previewData} /> */}
      </div>
       
    <div style={{marginRight:"20px" , maxWidth:"100%"}} className="drawer-item">

      {contextHolder}

      <Steps
      className="desktop"
      size="small"
      current={currentStep}
      items={[
        {
          title: 'Product',
        },
        {
          title: 'Trigger',
        },
        {
          title: 'DM',
        },
         ...(props.state?.sp_send_type != "link" ? [{
          title: 'DM Followup',
        },
         {
          title: 'Cart Followup',
        },
        {
          title: 'Post Purchase',
        },] :[])
        //  {
        //   title: 'Out of stock',
        // },
      ]}
    />


       { currentStep == 1 && 
       <>
       <div style={{backgroundColor:"white", padding:"20px", borderRadius:"10px  20px 10px 20px"}}>
        <div style={{display:"flex" , flexDirection:"row" , justifyContent:"space-between"}}>
        <h3>Comment Trigger</h3>
        <CommentOutlined style={{fontSize:"20px"}} />
        </div>
        <div className="flex-divider">
        <div  style={{display:"flex",  flexDirection:"row", gap:"20px", overflowX:"scroll",height:"auto" ,maxHeight: 300, marginBottom:"20px"}}>
          {!props.isDMAuto &&
            <Radio.Group onChange={(e) => { props.setData({ ...props.state, auto_reply: { ...props.state.auto_reply, automate_all: e.target.value } }) }} value={props.state?.auto_reply?.automate_all || "true"}>
              <Radio.Button value="false">{props.isStory ? "Specific DM Word" : "Specific Comments"}</Radio.Button>
              <Radio.Button value="true" disabled={!AccessOrNot("all_comment")}>{props.isStory ? "All DM for this story" : "All comments"} <CrownReturn premiumUser={AccessOrNot("all_comment")} /> </Radio.Button>
            </Radio.Group>
          }


        </div>
        {props.state.auto_reply.automate_all != "true" ?
            isAddingTag && addingType === 'tag' ? (
              <Input
                placeholder="Expected Word"
                ref={inputRef}
                type="text"
                size="large"
                style={{ width: '200px' }}
                value={inputValue}
                onChange={handleInputChange}
                onBlur={handleInputConfirm}
                onPressEnter={handleInputConfirm}
              />
            ) : (
              <>
                <Tag className="add-new-tag" onClick={() => showInput('tag')}>
                  <PlusOutlined /> Expected Word
                </Tag>


              </>
            )
            : <></>
            //  <p>{(props.isStory || props.isDMAuto) ? "All DM will be automated" : "All comments will be automated."}</p>

          }
          {props.state.auto_reply.automate_all != "true" && <div>{tagChild}</div>}
        </div>

        <Divider>Reply to comment</Divider>
        <div>
        
          <div className="flex-divider">


            {isAddingTag && addingType === 'comment' ? (
              <Input
                placeholder="Reply Comment"
                ref={commentRef}
                type="text"
                size="large"
                style={{ width: '300px' }}
                value={commentValue}
                onChange={handleInputChange}
                onBlur={handleInputConfirm}
                onPressEnter={handleInputConfirm}
              />
            ) : (
              <Tag style={{ width: '300px' }} className="add-new-tag" onClick={() => showInput('comment')}>
                <PlusOutlined /> Reply Comment
              </Tag>
            )}


            <div style={{ overflow: 'scroll' }}>{commentChild}</div>
            <div style={{ display: 'flex', flexDirection: "row", gap:"10px", alignItems: 'center', alignItems: 'center' }}>

              <Checkbox onChange={(e) => { props.setData({ ...props.state, auto_reply: { ...props.state.auto_reply, include_ai_comment_reply: e.target.checked } }) }} checked={props.state.auto_reply.include_ai_comment_reply != undefined ? props.state.auto_reply.include_ai_comment_reply : false} > Also Include AI Comment Reply (to prevent comment spam)</Checkbox>

            </div>
          </div>

        </div>
                {!props.isDMAuto && <div style={{ display: 'flex', flexDirection: "row", justifyContent: 'space-between', alignItems: 'center', alignItems: 'center' }}>
                    <h4>
                      Automate Post sent to your DM  <CrownReturn premiumUser={AccessOrNot("post_dm")} />
                    </h4>
                    <Switch disabled={!AccessOrNot("post_dm")} style={{ marginTop: '20px' }} onChange={(value) => { props.setData({ ...props.state, auto_reply: { ...props.state.auto_reply, dm_shared_reply: value } }) }} value={["true", true].includes(props.state.auto_reply.dm_shared_reply) ? true : false} />
                  </div>}
      </div>
      </>

        }


       { currentStep == 0 &&
        <div className="shopify-card-products" style={{backgroundColor:"white", padding:"20px", borderRadius:"10px  20px 10px 20px"}}>
        <div style={{display:"flex" , flexDirection:"row" , justifyContent:"space-between"}}
        
       
        >
        <h3>Select Product</h3>
        <RightCircleOutlined/>
        </div>
        <div  
        
         onWheel={(e) => {
                          const container = e.currentTarget;
                          // Only trigger if there's horizontal scroll
                          if (container.scrollWidth > container.clientWidth) {
                            container.scrollLeft += e.deltaY;
                            e.preventDefault(); // prevent page vertical scroll
                          }
                        }}
        
        style={{display:"flex",flexWrap:"wrap",  flexDirection:"row", gap:"20px", overflowX:"scroll",height:"auto" ,maxHeight: 400, marginBottom:"20px"}}>
           { products?.map( (product) => 

           <div style={{position:"relative"}}>
                 { product?.node?.id == props.state?.sp_id && <div
                    style={{
                      position: "absolute",
                      top: 14,
                      right: 14,
                      backgroundColor: "#4f8cff",
                      color: "#fff",
                      borderRadius: "50%",
                      width: 24,
                      height: 24,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: 14
                    }}
                  >
                    ✓
                  </div> }
                        <img
                      alt={product?.node?.title}
                      
                      src={product?.node?.featuredMedia?.preview?.image?.url  || "https://via.placeholder.com/300?text=No+Image"}
                      onClick={() => {
                        
                        setPreviewData({...previewData, sp_product: product})
                        setSelectedProduct(product?.node?.id)
                        props.setData({ ...props.state,sp_id:product?.node?.id, sp_product:product , sp_send_type:"sell", sp_send_message :null})
                      }


                      }
                      style={{ height: 160, objectFit: "cover", borderRadius:"20px", border: product?.node?.id == props.state?.sp_id ? "2px solid #4f8cff" :"1px solid rgba(0,0,0,.15)",cursor:"pointer" ,}}
                    />
                </div>
            )}
        </div>
      </div>
        }


       { currentStep == 2 && 
       
        <ShopifyChoice site_name={site_name} previewData={previewData} setPreviewData={setPreviewData} props={props} LoadPreview={LoadPreview}/>
        
        }


      { currentStep == 3 && 
      <div style={{backgroundColor:"white",minWidth:"300px",  padding:"20px", borderRadius:"10px  20px 10px 20px"}}>
        <div style={{display:"flex" , flexDirection:"row" , justifyContent:"space-between"}}>
        <h3 style={{fontWeight:500}}>Follow up : If customer not added product to cart</h3>
        <ClockCircleOutlined style={{fontSize:"20px"}} />
        </div>

        <FollowupSection varient="left_chat" old_messages={ Object.values(followupMessages?.left_chat)} setFollowupMessages={setFollowupMessages}   />
        
        </div>

      }

      { currentStep == 4 && 

      <div style={{backgroundColor:"white",minWidth:"300px",  padding:"20px", borderRadius:"10px  20px 10px 20px"}}>
        <div style={{display:"flex" , flexDirection:"row" , justifyContent:"space-between"}}>
        <h3 style={{fontWeight:500}}>Follow up : If customer added product to cart but not purchased</h3>
        <ClockCircleOutlined style={{fontSize:"20px"}} />
        </div>

        <FollowupSection varient="left_order" old_messages={Object.values(followupMessages?.left_order)} setFollowupMessages={setFollowupMessages}   />
        
        </div>
      
          // <div>
          //     <h3>If user saved to cart but not purchased the product</h3>

          //   <div className="followup-row">
          //   {[1, 2, 3].map((num) => (
          //     <p
          //       key={num}
          //       style={{
          //         fontWeight: ( selectedFollowupType=="left_order" && selectedFollowup === String(num)) ? "bold" : "normal",
          //         color:  ( selectedFollowupType=="left_order" && selectedFollowup === String(num) ) ? "#4f8cff" : undefined,
          //         cursor: "pointer"
          //       }}
          //       onClick={() => {
          //       setSelectedFollowupType("left_order")
          //       setSelectedFollowup(String(num))}
          //       }
          //     >
          //       Follow up #{num}
          //     </p>
          //   ))}
          // </div>
          // { selectedFollowupType == "left_order" &&<div>
          //   <div style={{display:"flex" , flexDirection:"row", gap:"10px", alignItems:"center", justifyContent:"space-between"}}>
          //     <h4>Follow up after</h4>
          //     <Select
          //     style={{ width: "60%", marginBottom: "10px" }}
          //     value={followupMessages["left_order"][selectedFollowup]?.follow_up_time}
          //     options={followup_options}
          //   />
          //   </div>
          //   <Input.TextArea
          //     placeholder="Follow up message"
          //     value={followupMessages["left_order"][selectedFollowup]?.message}
          //     onChange={(e) => {
          //       let temp_message = followupMessages.left_order[selectedFollowup]
          //       temp_message.message = e.target.value
          //       let new_message = followupMessages.left_order
          //       new_message[selectedFollowup] = temp_message
          //       setFollowupMessages(
          //         {
          //           ...followupMessages, "left_order": new_message
          //         }
          //       )
          //     }} // You can add editing logic if needed
          //   />
          //   <Input
          //     style={{ marginTop: "10px" }}
          //     placeholder="button(optional)"
          //     value={followupMessages["left_order"][selectedFollowup]?.button}
          //     onChange={(e) => {
          //        let temp_message = followupMessages.left_order[selectedFollowup]
          //       temp_message.button = e.target.value
          //       let new_message = followupMessages.left_order
          //       new_message[selectedFollowup] = temp_message
          //         setFollowupMessages(
          //         {
          //           ...followupMessages, "left_order": new_message
          //         }
          //       )
          //     }} // You can add editing logic if needed
          //   />
          // </div>}
          // </div>
      
      
        }
        { currentStep == 5 && 
        
        <PostPurchaseTimeline products={products} postPurchase={postPurchase} setPostPurchase={setpostPurchase} />
        
        }

      <div style={{display:"flex", alignContent:"flex-end", justifyContent:"flex-end", alignItems:"flex-end", justifyItems:"flex-end", gap:"10px"}}>
         { (currentStep > 0 ) &&

        <Button  onClick={() => {
          
          setCurrentStep(currentStep-1)

          
        }}  size="large" style={{maxWidth:"300px"}}>Previous</Button>

        }
       { (
  currentStep < steps.length - 1 && 
  !(currentStep === 2 && props.state?.sp_send_type === "link")
) &&  <Button  onClick={() => {
          setCurrentStep(currentStep+1)
        }} 
        
        disabled = {
          (currentStep === 0 && !props.state?.sp_id) ||
        (currentStep === 1 && (!props.state?.auto_reply?.triger_words?.length > 0 && !props.state?.auto_reply?.reply_comments?.length > 0) )
        }
        
        color="default" variant="solid" size="large" style={{maxWidth:"300px"}}>Next Step</Button>

      }
      {/* {<p>
         {currentStep} == {steps.length}
        </p>} */}
      {
        ( currentStep == steps.length-1 || (currentStep==2 && props.state?.sp_send_type == "link"  )) && <Button size="large" color="primary" variant="solid" onClick={() => {
          
          // console.log(props.state)
          props.HandleSPPublish()
        
        }}>Publish</Button>
      }
      </div>
      <div>
        
      </div>

      </div>
      <div className="mobile" >
        <ShopifyPreview igData={props.igData} step={steps[currentStep]} data = {props.state} previewData={previewData} />
        {/* data={previewData} /> */}
      </div>

      {/* {alert(props.state?.sp_id)} */}
      
      <Drawer 
      onClose={() => {setExpPreviewData(); setExpChat([])}}
      title="Preview your experience" width={"600px"} open={expPreviewData?.node?.id} >
        <InstaDMLayout>

          
          <div className="card-message" style={{borderRadius:"10px"}}>
            <img src={expPreviewData?.node?.featuredMedia?.preview?.image?.url} />
            <div className="card-content">
            <h3>{expPreviewData?.node?.title}</h3>
            <p>{splitIntoChunks(htmlToText(expPreviewData?.node?.description?.substring(0,100) ))?.[0]?.substring(0,100)}</p>
            <div className="card-button shake15" onClick={handleShopClick}>
            Shop Now
            </div>
            </div>

            

            {expChat.map((chat, index) =>  

                {
                  
                 if(chat.from == "user"){
                  return (
                  <div style={{marginTop:"20px"}} className="insta-text-message from-user" >
                  
                  <h3>{chat?.text}</h3>
                
                </div>
                 )

                }
                if(chat.from == "bot"){

                  if(chat.type == "image"){
                    return (
                      <div style={{marginTop:"20px", }} >
                        <img style={{height:"auto", borderRadius:"10px"}} src={chat?.src} />
                      </div>
                    )
                  }
                  if(chat.type == "text"){
                    return (
                      <div style={{marginTop:"0px"}} className="insta-text-message from-bot" >
                        <h3>{chat?.text}</h3>
                      </div>
                    )
                  }
                  if(chat.type == "text"){
                    return (
                      <div style={{marginTop:"20px"}} className="insta-text-message from-bot" >
                        <h3>{chat?.text}</h3>
                      </div>
                    )
                  }
                  if(chat.type == "button"){
                    return (
                     <div  className="card-message " style={{borderRadius:"10px"}}>
                    <img src={chat?.image_url} />
                    <div className="card-content">
                    <h3>{chat?.title }</h3>
                    <p>{chat?.subtitle }</p>
                    {chat?.buttons?.map((button, index) =>
                    <div className="card-button shake5">
                    {button.title}
                    </div>
                    )}

                    </div>
                    </div>
                  )
                  }
                   
                  if(chat.type == "products"){
                    
                    return <div className="shake" style={{display:"flex", flexDirection:"row",overflowX:"scroll", flexWrap:"nowrap", maxWidth:"100%"}}>
                    {chat.products.map( (message , item) =>
                    <div className="card-message" style={{borderRadius:"10px"}}>
                      <img src={message.image_url} />
                      <div className="card-content">
                      {message?.title && <h3>{message.title }</h3> }
                      {message?.subtitle && <p>{message?.subtitle }</p> }
                      {message.buttons.map((button, index) =>
                      <div className="card-button shake5" onClick={button?.onClick}>
                      {button.title}
                      </div>
                      )}

                      </div>
                      </div>
                    )}
                    </div>
                    }

                }

            }

          )

            
          }

          </div>

          
         { isTyping && <div className="message-bubble bot">
            <div className="typing-animation">
              <span></span><span></span><span></span>
            </div>
          </div> }
        </InstaDMLayout>
      </Drawer>
      </div>
  );
}


export { ShopifyAutomate }